import { BaseState } from './base-state';
import { TasksCounters } from '@models/tasks/tasks-counters';
import { ChatsCounters } from '@models/chats/chat-counters';
import { MentionsCounters } from '@models/chats/mentions-counters';
import { RecursivePartial } from '../base';
import { CalendarCounters } from '../events';

export class CountersState extends BaseState {

    tasks: TasksCounters = new TasksCounters();
    chats: ChatsCounters = new ChatsCounters();
    mentions: MentionsCounters = new MentionsCounters();
    calendar: CalendarCounters = new CalendarCounters();

    constructor(json?: RecursivePartial<CountersState>) {
        super(json);
        this.parseCountersState(json || {});
    }

    parse(json: RecursivePartial<CountersState>): CountersState {
        super.parse(json);
        this.parseCountersState(json);
        return this;
    }

    private parseCountersState(json: RecursivePartial<CountersState>): void {
        CountersState.assignClassFields<CountersState>(this, json, {
            tasks: TasksCounters,
            chats: ChatsCounters,
            mentions: MentionsCounters,
            calendar: CalendarCounters
        });
    }

}
